import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import trcCompanyModalStyles from './truckingCompanyModal.module.css';
import commonStyles from '../../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    submitBtn: {
      margin: '10px 20px'
    }
  });

interface TruckingCompanyModalProps {
  classes: any;
  modalOpen: boolean;
  name: string;
  email:string;
  phoneNumber: string;
  isPhoneNumber: boolean;
  isEmail: boolean;
  isValidName: boolean;
  errorName: string;
  prefixPhoneNumber: string;
  handleCloseModal: () => void;
  handleChange: Function;
  handleSubmit: Function;
  onValidationName: any;
  onValidationEmail: any;
  onValidationPhoneNumber: any;
};

const truckingCompanyModal = (props: TruckingCompanyModalProps) => {
  
  const { classes } = props;
  const phoneNumber: string = props.phoneNumber.replace('+1', '');
  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ props.handleCloseModal }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'md' }
    >
      <DialogTitle id="form-dialog-title">
        <div className={ trcCompanyModalStyles.title }>
          <span>Create new Trucking company</span>
          <IconButton aria-label="Close" onClick={ props.handleCloseModal }>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div className={ `${ commonStyles.wrapper } ${ commonStyles.mb0 }` }>
          <div className={ commonStyles.inputLabelWrapper }>
            <label className={ commonStyles.inputLabel }>Name</label>
            <TextField 
              required
              id="name"
              value={ props.name }
              onChange={ (event) => props.handleChange('name', event) }
              onBlur={ props.onValidationName } 
              error={ !props.isValidName }
              helperText={ !props.isValidName ? `${ props.errorName }` : '' }
              variant="outlined"
            />
          </div>
          <div className={ commonStyles.inputLabelWrapper }>
            <label className={ commonStyles.inputLabel }>Email</label>
            <TextField 
              id="email"
              value={ props.email }
              onChange={ (event) => props.handleChange('email', event) }
              onBlur={ props.onValidationEmail } 
              error={ !props.isEmail }
              helperText={ !props.isEmail ? 'The email is not valid!' : '' }
              variant="outlined"
            />
          </div>
          <div className={ commonStyles.inputLabelWrapper }>
            <label className={ commonStyles.inputLabel }>Phone Number</label>
            <TextField 
              id="phoneNumber"
              placeholder='Phone number must be at least ten digits long.'
              InputProps={{
                startAdornment: <InputAdornment position="start">{ props.prefixPhoneNumber }</InputAdornment>,
              }}
              value={ phoneNumber }
              onChange={ (event) => props.handleChange('phoneNumber', event) }
              onBlur={ props.onValidationPhoneNumber } 
              error={ !props.isPhoneNumber }
              helperText={ !props.isPhoneNumber ? 'Phone number must be at least ten digits long.' : '' }
              variant="outlined"
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button 
          className={ classes.submitBtn }
          variant="contained" 
          color="primary" 
          disabled={ !props.isValidName || !props.isPhoneNumber || !props.isEmail }
          onClick={ () =>  props.handleSubmit() }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(truckingCompanyModal);